import React, { useState } from 'react'
import {
    AppBar,
    Toolbar,
    Divider,
    ListItemText,
    Button,
    Box,
    Link,
    Drawer,
    IconButton,
    List,
    ListItem
} from "@mui/material";
import { motion } from "framer-motion";
import { fadeInUp } from '../../utils/animations';
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "../../assets/img/Get_Sorted_Logo.webp"


const FrontendNav = () => {

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setIsDrawerOpen(open);
    };

    const menuItems = [
        { label: "Home", href: "#home" },
        { label: "About", href: "#about" },
        { label: "Errand Services", href: "#errand-services" },
        { label: "How It Works", href: "#how-it-works" },
        { label: "Contact", href: "#contact" },
    ];

    return (
        <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
        >
            <AppBar id="home" position="static" style={{ backgroundColor: "white" }}>
                <Toolbar>
                    { }
                    {/* Hamburger menu for mobile */}
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={toggleDrawer(true)}
                        sx={{ display: { xs: "block", md: "none" }, color: "black" }} // Show only on mobile
                    >
                        <MenuIcon />
                    </IconButton>

                    { }
                    {/* Centered logo */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexGrow: 1,
                            position: { xs: "static", md: "absolute" }, // Static on mobile, absolute on desktop
                            left: { xs: "auto", md: "50%" }, // Center horizontally on desktop
                            transform: { xs: "none", md: "translateX(-50%)" },
                        }}
                    >
                        <Box
                            component="img"
                            src={`${Logo}`}
                            alt="Logo"
                            sx={{
                                width: "50px", // Adjust size as needed
                                height: "50px", // Adjust size as needed
                                borderRadius: "8px", // Optional: Add rounded corners
                            }}
                        />
                    </Box>

                    { }
                    {/* Desktop menu */}
                    <Box
                        sx={{
                            display: { xs: "none", md: "flex" }, // Hide on mobile, show on desktop
                            justifyContent: "flex-start",
                            flexGrow: 1,
                            marginLeft: "16px",
                        }}
                    >
                        {menuItems.map((item) => (
                            <Link
                                key={item.label}
                                href={item.href}
                                style={{ margin: "0 15px", textDecoration: "none", color: "black" }}
                            >
                                {item.label}
                            </Link>
                        ))}
                    </Box>

                    { }
                    {/* Desktop button */}
                    <Box
                        sx={{
                            display: { xs: "none", md: "flex" }, // Hide on mobile, show on desktop
                            justifyContent: "flex-end",
                            flexGrow: 1,
                            marginRight: "16px",
                        }}
                    >
                        <Button
                            style={{ backgroundColor: "#ea6d58", color: "white" }}
                            disabled
                        >
                            Sign In
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>

            { }
            {/* Offcanvas menu for mobile */}
            <Drawer
                anchor="left" // Open from the left
                open={isDrawerOpen}
                onClose={toggleDrawer(false)}
                sx={{
                    "& .MuiDrawer-paper": {
                        width: "100%", // Full width
                        maxWidth: "300px", // Limit maximum width
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        padding: "16px",
                    }}
                >
                    {/* Centered logo in the offcanvas menu */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            mb: 2,
                        }}
                    >
                        <Box
                            component="img"
                            src={`${Logo}`}
                            alt="Logo"
                            sx={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "8px",
                            }}
                        />
                    </Box>

                    <Divider sx={{ mb: 2 }} />

                    {/* Menu items */}
                    <List>
                        {menuItems.map((item) => (
                            <ListItem
                                key={item.label}
                                component={Link}
                                href={item.href}
                                onClick={toggleDrawer(false)}
                                sx={{
                                    textDecoration: "none",
                                    color: "black",
                                    "&:hover": {
                                        backgroundColor: "#f5f5f5",
                                    },
                                }}
                            >
                                <ListItemText primary={item.label} />
                            </ListItem>
                        ))}
                    </List>

                    {/* Full-width button */}
                    <Box sx={{ mt: "auto", width: "100%" }}>
                        <Button
                            as={Link}
                            to={'#contact'}
                            fullWidth
                            style={{ backgroundColor: "#ea6d58", color: "white" }}
                            disabled
                        >
                            Get In Touch
                        </Button>
                    </Box>
                </Box>
            </Drawer>
        </motion.div>
    )
}

export default FrontendNav;